module.exports = __webpack_public_path__ + "static/img/vio_ban_ar.b5d54f35.png";